import classNames from 'classnames/bind';
import styles from './Policy.module.scss';
import { AppBar, Box, Typography } from '@mui/material';
import { images } from '~/assets';
import { useTranslation } from 'react-i18next';

const cx = classNames.bind(styles);

const DeleteAccount = () => {
  //#region Destructuring Props
  //#endregion Destructuring Props
  //#region Declare Hook
  const { t } = useTranslation(['admin/common']);

  //#endregion Declare Hook
  //#region Selector
  //#endregion Selector
  //#region Declare State
  //#endregion Declare State
  //#region Implement Hook
  //#endregion Implement Hook
  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box className={cx('w-full', 'h-full')}>
      <AppBar
        color='inherit'
        className={cx('px-4 md:px-20 py-2.5 border-b border-[#E5EAEF]')}
        elevation={0}
        position='relative'
      >
        <Box className={cx('flex justify-between items-center')}>
          <img src={images.logo} alt='' className={cx('w-[61px] h-[62px]')} />
          <Box className={cx('h-9')}></Box>
        </Box>
      </AppBar>

      <Box className={cx('container')}>
        <Box className={cx('header')}>
          <Typography className={cx('header-title')}>{t('privacypolicy')}</Typography>
        </Box>

        <Box className={cx('content')}>
          <Box>
            <Typography variant='h5' className={cx('section-heading')} gutterBottom>
              Privacy Policy
            </Typography>
          </Box>

          <Box className={cx('section')}>
            <Typography className={cx('section-paragraph')}>
              <Box className={cx('section-title')}>Effective Date:</Box> 01/01/2025
            </Typography>
            <Typography className={cx('section-paragraph')}>
              Phoenix Tech, LLC (“we,” “our,” or “us”) is committed to protecting your privacy. This Privacy Policy
              explains how we collect, use, disclose, and safeguard your information when you use our services, website,
              or applications (collectively, the “Services”). By using our Services, you agree to the practices
              described here.
            </Typography>
          </Box>

          <Box className={cx('section')}>
            <Typography className={cx('section-title')}>1. Information We Collect</Typography>
            <Box className={cx('sub-section')}>
              <Typography className={cx('sub-section-title')}>1.1 Personal Information</Typography>
              <Typography className='mb-[20px]'>We may collect information you provide directly, such as:</Typography>

              <ul className={cx('list')}>
                <li>Name</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Billing and shipping address</li>
                <li>Payment information (e.g., credit card details)</li>
              </ul>
            </Box>
            <Box className={cx('sub-section')}>
              <Typography className={cx('sub-section-title')}>1.2 Non-Personal Information</Typography>
              <Typography className='mb-[20px]'>
                We may collect certain data automatically when you use our Services, such as:
              </Typography>
              <ul className={cx('list')}>
                <li>Browser type and version</li>
                <li>IP address</li>
                <li>Device type and operating system</li>
                <li>Usage data (e.g., pages visited, time spent on the site)</li>
              </ul>
            </Box>
            <Box className={cx('sub-section')}>
              <Typography className={cx('sub-section-title')}>1.3 Cookies and Tracking Technologies</Typography>
              <Typography>
                We use cookies, web beacons, and similar technologies to improve functionality, analyze usage, and
                enhance your experience. You can adjust cookie settings in your browser.
              </Typography>
            </Box>
          </Box>
          <Box className={cx('line')}></Box>
          <Box className={cx('section')}>
            <Typography className={cx('section-title')}>2. How We Use Your Information</Typography>
            <Box className={cx('sub-section')}>
              <Typography>We use the information we collect to:</Typography>
              <ul className={cx('list')}>
                <li>Provide, maintain, and improve our Services</li>
                <li>Process transactions and billing</li>
                <li>Communicate with you about updates, promotions, and other relevant content</li>
                <li>Analyze usage to enhance our Services</li>
                <li>Ensure security, prevent fraud, and comply with laws</li>
              </ul>
            </Box>
          </Box>
          <Box className={cx('line')}></Box>
          <Box className={cx('section')}>
            <Typography className={cx('section-title')}>3. Sharing Your Information</Typography>
            <Box className={cx('sub-section')}>
              <Typography>
                We do not sell or rent your personal information to third parties. We also do not share mobile opt-in
                data with third parties for marketing or promotional purposes.
              </Typography>
              <Typography>We may share your information only in the following situations:</Typography>
            </Box>
            <Box className={cx('sub-section')}>
              <Typography className={cx('sub-section-title')}>3.1 With Service Providers</Typography>
              <Typography>
                We work with trusted third-party service providers (e.g., payment processors, analytics providers) who
                assist us in operating our Services. These providers are contractually required to protect your
                information..
              </Typography>
            </Box>
            <Box className={cx('sub-section')}>
              <Typography className={cx('sub-section-title')}>3.2 For Legal Obligations</Typography>
              <Typography>
                We may disclose your information when required by law, legal process, or to protect our legal rights,
                safety, or property.
              </Typography>
            </Box>
            <Box className={cx('sub-section')}>
              <Typography className={cx('sub-section-title')}>3.3 Business Transfers</Typography>
              <Typography>
                If we undergo a merger, acquisition, or sale of assets, your information may be transferred to the new
                ownership.
              </Typography>
            </Box>
          </Box>
          <Box className={cx('line')}></Box>
          <Box className={cx('section')}>
            <Typography className={cx('section-title')}>4. Data Retention</Typography>
            <Box className={cx('sub-section')}>
              <Typography>
                We retain your personal information only as long as necessary to fulfill the purposes outlined in this
                Privacy Policy, meet legal obligations, or resolve disputes.
              </Typography>
            </Box>
          </Box>
          <Box className={cx('line')}></Box>
          <Box className={cx('section')}>
            <Typography className={cx('section-title')}>5. Your Rights</Typography>
            <Box className={cx('sub-section')}>
              <Typography>Depending on your location, you may have certain privacy rights, such as:</Typography>

              <ul className={cx('list')}>
                <li>The right to access and obtain a copy of your personal data</li>
                <li>The right to request correction or deletion</li>
                <li>The right to object to or restrict certain processing</li>
                <li>The right to data portability</li>
                <li>The right to withdraw consent when processing is based on consent</li>
              </ul>

              <Typography className='flex items-center'>
                To exercise these rights, contact us at
                <Box className={cx('sub-section-title-text')}>phoenixtechapp@gmail.com.</Box>
              </Typography>

              <Typography className='mb-[20px]'>
                Note: Rights vary by jurisdiction. If you are a California resident, you may have additional rights
                under the California Consumer Privacy Act (CCPA). If you are in the European Economic Area (EEA), you
                may have rights under the General Data Protection Regulation (GDPR).
              </Typography>
            </Box>
          </Box>
          <Box className={cx('line')}></Box>
          <Box className={cx('section')}>
            <Typography className={cx('section-title')}>6. Data Security</Typography>
            <Box className={cx('sub-section')}>
              <Typography>
                We use appropriate technical and organizational safeguards to protect your information from unauthorized
                access, disclosure, alteration, or destruction. However, no internet-based service is 100% secure.
              </Typography>
            </Box>
          </Box>
          <Box className={cx('line')}></Box>
          <Box className={cx('section')}>
            <Typography className={cx('section-title')}>7. Third-Party Links</Typography>
            <Box className={cx('sub-section')}>
              <Typography>
                Our Services may contain links to external websites. We are not responsible for the privacy practices or
                content of those sites.
              </Typography>
            </Box>
          </Box>
          <Box className={cx('line')}></Box>
          <Box className={cx('section')}>
            <Typography className={cx('section-title')}>8. Children’s Privacy</Typography>
            <Box className={cx('sub-section')}>
              <Typography>
                Our Services are not directed to individuals under the age of 16. We do not knowingly collect personal
                information from children. If we become aware that we have collected such information, we will delete it
                promptly
              </Typography>
            </Box>
          </Box>
          <Box className={cx('line')}></Box>
          <Box className={cx('section')}>
            <Typography className={cx('section-title')}>9. Changes to This Privacy Policy</Typography>
            <Box className={cx('sub-section')}>
              <Typography>
                We may update this Privacy Policy from time to time. Any updates will be posted here with a revised
                “Effective Date.” Continued use of our Services after changes are posted constitutes your acceptance of
                the changes.
              </Typography>
            </Box>
          </Box>
          <Box className={cx('line')}></Box>
          <Box className={cx('section')}>
            <Typography className={cx('section-title')}>10. Contact Us</Typography>
            <Box className={cx('sub-section')}>
              <Typography>
                If you have any questions about this Privacy Policy or our data practices, please contact us at:
              </Typography>
            </Box>

            <Typography variant='h5' className={cx('section-heading')} gutterBottom>
              Phoenix Tech, LLC
            </Typography>
            <Typography>
              <Box className='flex items-center'>
                Email: <Box className={cx('sub-section-title-text')}> Phoenixtechapp@gmail.com</Box>
              </Box>
            </Typography>
            <Typography>
              <Box className='flex items-center'>
                Phone: <Box className={cx('sub-section-title-text')}>(720) 204-2095</Box>
              </Box>
            </Typography>

            <Typography>
              <Box className='flex items-center'>
                Address:
                <Box className={cx('sub-section-title-text')}>8200 Southpark Circle, Unit 300, Littleton CO 80120</Box>
              </Box>
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DeleteAccount;
